import styled, { keyframes } from 'styled-components'

const rotate = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`

export const LoadingMask = styled.div`
  ${props => props.loading ? 'display:inline-block;' : 'display:none;'}
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.5);
  z-index: 9999;
`

export const Container = styled.div`
  width: 2rem;
  height: 2rem;
  vertical-align: text-bottom;
  border: .25em solid;
  border-right: .25em solid transparent;
  border-radius: 50%;
  animation: ${rotate} .5s linear infinite;
  z-index: 99;
  position: fixed;
  left: calc(50% - 1rem);
  top: calc(50% - 1rem);
  color: #00a3b4;
`
